import React, { Component } from 'react';
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';
import GetDomains from '../../GetDomains';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ReactJson from 'react-json-view';

class SlotExtraction extends Component {
  constructor() {
    super();
    this.state = {
      domainId: null,
      successResp: false,
      inputVal: '',
      outputJson: '',
      languageVal: { value: '', label: '' },
      intentVal: { value: '', label: '' },
      showExpandedPopup: false,
      disableExpand: true
    }
    this.languageOptions = [];
    this.intentOptions = [];
    this.slotOptions = [];
  }

  notifyFailToLoad(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }

  handleChangeInput = (e) => {
    this.setState({ inputVal: e.target.value });
  }

  resetData = () => {
    document.getElementById("inputVal").value = "";
    document.getElementById("outputVal").value = "";
  }

  langhandleChange = (e) => {
    this.state.languageVal = { value: e.value, label: e.label }
    this.setState(this.state);
  }

  domainhandleChange = (e) => {
    this.fetchIntentsApi()
    this.fetchSlotApi()
  }
  intenthandleChange = (e) => {
    this.fetchSlotApi()
  }

  notifyFailToLoadLanguages() {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>Oops! Error occurred loading languages.Please try again</b>, {
      position: "top-center",
      color: "red"
    });
  }

  fetchLanguagesApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var languageController = this;
    $.ajax(
      {
        url: "/api/project-languages-selected",
        async: false,
        method: 'GET',
        data: {
          projectId: projectId
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token")
        },
        success: function (res) {
          if (res.success === true) {
            var loadedLang = res.result;

            languageController.setState({ language: loadedLang });
            var numberOfLanguages = loadedLang.length;
            var ele3 = document.getElementById("languageIdDropDown");

            if (ele3 != null) {
              if (ele3 != "") {
                ele3.innerHTML = "";
              }

              for (var i = 0; i < numberOfLanguages; i++) {
                ele3.innerHTML = ele3.innerHTML + '<option value="' + loadedLang[i]
                ['code'] + '">' + loadedLang[i]['name'] + '</option>';
              }
            }
          }
          else {
            languageController.notifyFailedLoad(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    )

  }

  fetchIntentsApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var intentController = this;
    var domainId;
    if (document.getElementById('domainDropDown') != null) {
      domainId = document.getElementById('domainDropDown').value;
    }
    $.ajax({
      url: "/api/slu-intent",
      async: false,
      method: 'GET',
      data: {
        "projectId": projectId,
        domainId: domainId,
      },
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          var loadedIntent = res.result;

          intentController.setState({ language: loadedIntent });
          var numberOfIntents = loadedIntent.length;
          var ele3 = document.getElementById("intentDropDown");

          if (ele3 != null) {
            if (ele3 != "") {
              ele3.innerHTML = "";
            }

            for (var i = 0; i < numberOfIntents; i++) {
              ele3.innerHTML = ele3.innerHTML + '<option value="' + loadedIntent[i]
              ['id'] + '">' + loadedIntent[i]['name'] + '</option>';
            }
          }

        }
        else {
          intentController.notifyFailToLoadData(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  fetchSlotApi = () => {
    var fetchController = this;
    var intentId;
    if (document.getElementById('intentDropDown') != null) {
      intentId = document.getElementById('intentDropDown').value;
    }
    $.ajax({
      url: "/api/slots",
      async: false,
      method: 'GET',
      data: {
        intentId: intentId

      },
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          var loadedSlots = res.result;

          fetchController.setState({ language: loadedSlots });
          var numberOfSlots = loadedSlots.length;
          var ele3 = document.getElementById("slotDropDown");

          if (ele3 != null) {
            if (ele3 != "") {
              ele3.innerHTML = "";
            }

            for (var i = 0; i < numberOfSlots; i++) {
              ele3.innerHTML = ele3.innerHTML + '<option value="' + loadedSlots[i]
              ['id'] + '">' + loadedSlots[i]['name'] + '</option>';
            }
          }

        } else {
          fetchController.setState({

            successResp: false

          })

          fetchController.notifyError(res.result);
        }
      },

      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });

  }

  notifyError(response) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      {response}</b>, {
      position: "top-center"
    });
  }

  notifyFailToLoadData(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }


  notifyNoLangSelected() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Oops!you have not selected language for your project</b>, {
      position: "top-center"
    });
  }
  notifyNoSlotSelected() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Oops!you have not selected slot for your project</b>, {
      position: "top-center"
    });
  }

  notifyNoIntentSelected() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Oops!you have not selected intent for your project</b>, {
      position: "top-center"
    });
  }

  parseActionApi = () => {
    var languageController = this;
    if (document.getElementById('slotDropDown').value == "") {
      languageController.notifyNoSlotSelected();
    }
    else if (document.getElementById('slotDropDown').value == "") {
      languageController.notifyNoIntentSelected();
    }
    else {
      let apiUsageRecord = {
        projectId: localStorage.getItem("currentProjectId"),
        language: document.getElementById('languageIdDropDown').value,
        intentId: document.getElementById('intentDropDown').value,
        slotId: document.getElementById('slotDropDown').value,
        text: languageController.state.inputVal
      }
      if (localStorage.getItem("runtimeNodeName") != "null") {
        apiUsageRecord["runtimeNodeName"] = localStorage.getItem("runtimeNodeName");
      }
      $.ajax({
        url: "/api/slot-extraction-test",
        async: false,
        method: 'GET',
        data: apiUsageRecord,
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            languageController.state.outputJson = res.result;
            languageController.state.disableExpand = false;
            languageController.setState(languageController.state);
          } else {
            languageController.notifyFailToLoad(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      });
    }
  }

  componentDidMount() {
    let thisController = this;
    setTimeout(() => {
      this.fetchLanguagesApi();
      this.fetchLanguagesApi();
      this.fetchDomainApi();
      this.fetchIntentsApi();
      this.fetchSlotApi();
    }, 300);

    document.addEventListener("projectChanged", function (event) {
      if (thisController.isNullOrEmpty(document.getElementById("inputVal"))) {
        document.getElementById("inputVal").value = "";
      }
      if (thisController.isNullOrEmpty(document.getElementById("outputVal"))) {
        document.getElementById("outputVal").value = "";
      }
      thisController.projectId = event.projectId;
      thisController.languageOptions = [];
      thisController.slotOptions = [];
      thisController.intentOptions = [];
      thisController.fetchLanguagesApi(event.projectId);
      thisController.fetchDomainApi();
      thisController.fetchIntentsApi(event.projectId);
      thisController.fetchSlotApi();
    })
  }

  isNullOrEmpty(fieldVal) {
    if (fieldVal === "") {
      return false;
    } else if (fieldVal === null) {
      return false;
    } else if (fieldVal === undefined) {
      return false;
    } else {
      return true;
    }
  }

  fetchDomainApi = () => {
    var domain = GetDomains();
    this.setState({ domain: domain });
    var domainOptionTag = document.getElementById("domainDropDown");
    if (domainOptionTag != "") {
      if (domainOptionTag != null) {
        domainOptionTag.innerHTML = "";

        for (var i = 0; i < domain.length; i++) {
          domainOptionTag.innerHTML = domainOptionTag.innerHTML + '<option value="' +
            domain[i]["domainId"] + '">' + domain[i]["domain"] + '</option>';
        }
        this.setState({ domainId: document.getElementById('domainDropDown') })
        this.setState(this.state);
      }
    }

  }

  showExpandedPopupFunc = () => {
    this.state.showExpandedPopup = true;
    this.setState(this.state);
  }

  closeExpandedJsonPopup = () => {
    this.state.showExpandedPopup = false;
    this.setState(this.state);
  }

  render() {
    const yourJSON = this.state.outputJson.result;
    const copyText = JSON.stringify(yourJSON, null, 4);
    return (
      <div className="wrapper ovrfhide" style={{ height: "800px", background: "#FFFFFF" }}>

        <div >
          <div>
            {/* for toaster */}
            <link rel="stylesheet" href="assets/css/ReactToastify.css" />
            {/* for reactTable */}
            <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
            {/* pretty print json css*/}
            <link rel="stylesheet" href="./assets/css/prettyJson.css" />
            <link rel="stylesheet" type="text/css" href="./assets/css/widgetOverride.css" />

            <div className="content-header">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-sm-12">


                    {/* language */}
                    <div className="col-sm-6">
                      <h6 className="taglineTxt"></h6>
                      <label>Language</label>
                      <select
                        value={this.state.value}
                        id="languageIdDropDown" className="languageIdDropDown"
                        onChange={this.langhandleChange}
                        style={{
                          width: '50%', height: '30px', borderRadius: '4px',
                          backgroundColor: '#F9F9FB',
                          marginLeft: '16px'

                        }} >

                      </select>
                    </div>


                    {/* domain */}
                    <div className="col-sm-6">
                      <h6 className="taglineTxt"></h6>
                      <label>Domain</label>
                      <select
                        value={this.state.value}
                        id="domainDropDown" className="domainDropDown"
                        onChange={this.domainhandleChange}
                        style={{
                          height: '30px', borderRadius: '4px', width: '50%',
                          backgroundColor: '#F9F9FB', marginLeft: '18px'
                        }}>

                      </select>
                    </div>

                    {/* intent */}
                    <div className="col-sm-6">
                      <h6 className="taglineTxt"></h6>
                      <label >Intent</label>
                      <select
                        value={this.state.value}
                        id="intentDropDown" className="intentDropDown"
                        onChange={this.intenthandleChange}
                        style={{
                          height: '30px', borderRadius: '4px', width: '50%',
                          backgroundColor: '#F9F9FB', marginLeft: '42px'
                        }}>

                      </select>
                    </div>


                    {/* slotname */}
                    <div className="col-sm-6">
                      <h6 className="taglineTxt"></h6>
                      <label>Slot</label>
                      <select
                        value={this.state.value}
                        id="slotDropDown" className="slotDropDown"
                        onChange={this.slothandleChange}
                        style={{
                          height: '30px', borderRadius: '4px', width: '50%',
                          backgroundColor: '#F9F9FB', marginLeft: '42px'
                        }}>

                      </select>
                    </div>

                  </div>
                  <div className="col-sm-6">

                  </div>
                </div>
              </div>

              <div className="content">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-3" style={{ marginTop: "20px" }}>
                      <label>Input</label>
                      <div className="card" style={{ borderRadius: '10px' }}>
                        <textArea id="inputVal" value={this.state.inputVal} onChange={this.handleChangeInput} style={{ height: '200px', borderRadius: '10px' }} />
                      </div>
                    </div>
                    <div className="col-md-3" style={{ textAlign: 'center', marginTop: '36px', display: 'grid' }}>
                      <button className="btn2 table-action-button "
                        title="Parse your input"
                        onClick={this.parseActionApi}
                        style={{
                          width: '80px', height: '36px', marginLeft: 'auto', marginRight: 'auto',
                          marginTop: 'auto'
                        }}>Test</button>
                      <button className="btn2 table-action-button "
                        onClick={this.resetData}
                        title="Reset your input"
                        style={{ width: '80px', height: '36px', marginLeft: 'auto', marginRight: 'auto', marginBottom: '54px' }}>
                        <img src="assets/images/reset.png" />
                      </button>
                    </div>
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-sm-6">
                          <label style={{ marginTop: "20px" }}>Output</label>
                        </div>
                        <div className="col-sm-6" Align="right">
                          <CopyToClipboard text={copyText}>
                            <button className="btn action-button" style={{ marginBottom: "10px" }} title="copy content"><img src="./assets/images/copy.png" /></button>
                          </CopyToClipboard>
                          <button className="btn action-button" disabled={this.state.disableExpand} style={{ marginBottom: "10px" }}
                            title="Expand content" onClick={this.showExpandedPopupFunc}>
                            <img style={{ width: "23px", height: "25px" }}
                              src="./assets/images/expand.png" /></button>
                        </div>
                      </div>


                      <div className="card">
                        <JSONPretty data={yourJSON}
                          id="outputVal"
                          style={{
                            height: '200px', border: 'none',
                            overflowY: yourJSON !== undefined ? "scroll" : "hidden"
                          }}></JSONPretty>

                      </div>
                      <ToastContainer className="Toast-at-center" />

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal" style={{ display: this.state.showExpandedPopup ? 'block' : 'none', marginLeft: "49%", width: "auto" }}>
          <div className="modal-dialog">
            <div className="modal-content" style={{ height: "100%" }}>
              <div className="modal-header noBorder">
                <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={this.closeExpandedJsonPopup}>
                  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                  </svg>
                </button>
              </div>
              <div className="modal-body">
                <ReactJson src={yourJSON}
                  iconStyle="square"
                  enableClipboard={true}
                  displayDataTypes={false}
                  style={{ height: "500px", overflowY: "auto" }} />
              </div>
            </div>
          </div>
        </div>

      </div>
    )
  }

}

export default SlotExtraction;



// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/tabsComponent/SlotExtraction.js